export type LegalDocumentType =
  | 'platform_terms'
  | 'terms_of_use'
  | 'privacy_policy'
  | 'cookie_policy'

export interface LegalDocumentAdminItem {
  id: number
  document_type: LegalDocumentType
  document_type_label: string
  version: string
  content: string
  is_current: boolean
  published_at: string | null
  published_by_admin_id: number | null
  created_at: string | null
  updated_at: string | null
}

export interface LegalDocumentsAdminListResponse {
  document_type: LegalDocumentType
  document_type_label: string
  current: LegalDocumentAdminItem | null
  versions: LegalDocumentAdminItem[]
}

export interface LegalDocumentPublicItem {
  document_type: LegalDocumentType
  title: string
  version: string
  content: string
  published_at: string | null
}

export interface CurrentTermsBundlePayload {
  documents: LegalDocumentPublicItem[]
  confirmation_phrase: string
  bundle_version: string | null
  updated_at: string | null
}

export interface LegalDocumentStatusItem {
  document_type: LegalDocumentType
  title: string
  current_version: string | null
  accepted_version: string | null
  accepted_at: string | null
  acceptance_required: boolean
}

export const LEGAL_DOCUMENT_TABS: {
  type: LegalDocumentType
  label: string
  path: string
}[] = [
  { type: 'platform_terms', label: 'Termos da Plataforma', path: '/termos-politicas' },
  { type: 'terms_of_use', label: 'Termos de Uso', path: '/termos-politicas/termos-de-uso' },
  {
    type: 'privacy_policy',
    label: 'Política de Privacidade',
    path: '/termos-politicas/privacidade',
  },
  { type: 'cookie_policy', label: 'Política de Cookies', path: '/termos-politicas/cookies' },
]

export interface LegalDocumentAcceptanceRow {
  id: number
  acceptor_type: 'institution' | 'collaborator'
  acceptor_type_label: string
  acceptor_id: number
  name: string
  email: string
  institution_name: string
  document_type: LegalDocumentType
  document_type_label: string
  document_version: string
  accepted_at: string
  accepted_ip: string | null
  accepted_user_agent: string | null
}

export interface LegalDocumentAcceptancesPagination {
  current_page: number
  per_page: number
  total: number
  last_page: number
}

export interface LegalDocumentAcceptancesListResponse {
  items: LegalDocumentAcceptanceRow[]
  pagination: LegalDocumentAcceptancesPagination
}

export const LEGAL_POLICIES_ADMIN_TABS = [
  { value: 'platform_terms', label: 'Termos da Plataforma', to: '/termos-politicas' },
  {
    value: 'acceptances',
    label: 'Dashboard de aceites',
    to: '/termos-politicas/aceites',
    icon: 'mdi:clipboard-check-outline',
  },
  { value: 'terms_of_use', label: 'Termos de Uso', to: '/termos-politicas/termos-de-uso' },
  { value: 'privacy_policy', label: 'Política de Privacidade', to: '/termos-politicas/privacidade' },
  { value: 'cookie_policy', label: 'Política de Cookies', to: '/termos-politicas/cookies' },
] as const
